/** Map chat_messages (OpenAI-format) to TranscriptDisplay events */
export function messagesToTranscript(messages: any[]) {
  return messages.flatMap((m) => {
    if (m.role === 'user') {
      return [{ type: 'turn' as const, role: 'Callee', text: typeof m.content === 'string' ? m.content : JSON.stringify(m.content) }]
    }
    if (m.role === 'assistant') {
      const events: unknown[] = []
      if (m.content) {
        events.push({ type: 'turn', role: 'Agent', text: typeof m.content === 'string' ? m.content : JSON.stringify(m.content) })
      }
      if (m.tool_calls) {
        const calls = Array.isArray(m.tool_calls) ? m.tool_calls : []
        for (const tc of calls) {
          const name = tc?.function?.name ?? tc?.name ?? 'tool'
          let args: unknown = tc?.function?.arguments
          try { args = typeof args === 'string' ? JSON.parse(args) : args } catch { /* leave as string */ }
          events.push({ type: 'tool_call', name, args, id: tc?.id })
        }
      }
      return events
    }
    if (m.role === 'tool') {
      let result: unknown = m.content
      try { result = typeof m.content === 'string' ? JSON.parse(m.content) : m.content } catch { /* leave as string */ }
      const isError = typeof result === 'object' && result !== null && ('error' in result || (result as any).success === false)
      return [{ type: 'tool_result' as const, name: m.name ?? 'tool', status: (isError ? 'error' : 'success') as 'success' | 'error', result, id: m.tool_call_id }]
    }
    if (m.role === 'event') {
      let result: unknown = m.content
      try { result = typeof m.content === 'string' ? JSON.parse(m.content) : m.content } catch { /* leave as string */ }
      const isError = typeof result === 'object' && result !== null && ('error' in result || (result as any).success === false)
      const name = m.name === 'llm_error' ? 'LLM Error' : m.name ?? 'event'
      return [{ type: 'tool_result' as const, name, status: (isError ? 'error' : 'success') as 'success' | 'error', result }]
    }
    return []
  })
}
